module.exports = __webpack_public_path__ + "static/media/melon.3353042b.svg";